import { IoTime } from "react-icons/io5";
import CustomText from "../atoms/custom-text.atom";
import CustomButton from "../atoms/custom-button.atom";
import { useDynamicLink } from "../../hooks/useDynamicLink";

export const EvaluationV2Template = () => {
  const downloadAppDynamicLink = useDynamicLink();

  function handleAppDownload(){
    const userAgent = navigator.userAgent.toLowerCase();
    const isIOS = /iphone|ipad|ipod/.test(userAgent);
    if (isIOS) {
      window.open(downloadAppDynamicLink.ios, '_blank');
    } else {
      window.open(downloadAppDynamicLink.android, '_blank');
    }
  }

  return <div style={{marginTop: '56px', justifyContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column', gap: '48px', padding: '0 32px'}}>
    <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '16px'}}>
        <CustomText variant="headline4xl" style={{textAlign: 'center'}}>
            ¡Recibimos tu solicitud!
        </CustomText>
        <CustomText variant="headlineLg" style={{textAlign: 'center'}}>
            Estamos revisando tu solicitud de préstamo por $750,00
        </CustomText>    
    </div>
    <img src={'./images/icons/Frame.png'} alt="Fito" />
    <CustomText variant="body">
      Te enviaremos un mensaje por WhatsApp cuando tengamos una respuesta. Visita nuestra página www.belozmexico.com.mx para más información y/o descarga nuestra app en el botón de abajo :point_down::skin-tone-3:
    </CustomText>
      <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', gap: '16px'}}>
        <IoTime size="32px" color="#164293" />
        <CustomText>
          Tiempo estimado de respuesta:{' '}
          <CustomText variant="subtitle"> 2 a 3 minutos</CustomText>
        </CustomText>
      </div>
      <CustomButton
        variant="yellow"
        onClick={handleAppDownload}
      >
        Descarga la app
      </CustomButton>

  </div>;
};
